module.exports = __webpack_public_path__ + "static/media/bitmap3919D27C.5ecd5b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bitmap3919D27C.png
// module id = 763
// module chunks = 0